var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"add-to-cart-btn",attrs:{"disabled":_vm.disabled},on:{"click":_vm.buttonClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.t('button')))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }